module.exports = __webpack_public_path__ + "media/footer/x-433f018c.svg";